import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchPieChartDataApi = async (coachId, startDate, endDate) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_PIECHART_DATA}/${coachId}`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  );
  return response.data;
};

// Fetch Client Analytics Data API
export const fetchClientAnalyticsApi = async (coachId, startDate, endDate) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_CLIENT_ANALYTICS}/${coachId}`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  );
  return response.data;
};
